"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cosmicPalette = void 0;

/**
 * A Palette of colors for data visualizations
 */
var cosmicPalette = {
  cosmic10: '#DCEAF7',
  cosmic30: '#BDDAF2',
  cosmic60: '#83BCEB',
  cosmic: '#3393E0',
  cosmicDark: '#0D70BF',
  cosmicDarkest: '#00447C'
};
exports.cosmicPalette = cosmicPalette;